import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { PrintRoute } from "~/providers/printing-provider";

interface PrintRouteStoreState {
  selectedPrintRoute?: PrintRoute;
  setSelectedPrintRoute: (printRoute?: PrintRoute) => void;
  printRouteDialogOpen: boolean;
  setPrintRouteDialogOpen: (open: boolean) => void;
}

export const usePrintRouteStore = create<PrintRouteStoreState>()(
  devtools((set) => ({
    printRouteDialogOpen: false,
    setPrintRouteDialogOpen: (open) => {
      set(() => ({ printRouteDialogOpen: open }));
    },
    setSelectedPrintRoute: (button) => {
      set(() => ({ selectedPrintRoute: button }));
    },
  })),
);
